module.exports = __webpack_public_path__ + "static/media/unaro-full.d5c78a35.svg";